import React from 'react';
import PropTypes from 'prop-types';
import clxBind from 'classnames/bind';
import styles from './styles.module.scss';

const clx = clxBind.bind(styles);

export default class Form extends React.Component {
  static propTypes = {
    layout: PropTypes.oneOf(['vertical', 'horizontal', 'inline']),
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
  };

  static defaultProps = {
    layout: 'horizontal',
    className: undefined,
  };

  static childContextTypes = {
    form: PropTypes.shape({
      layout: PropTypes.oneOf(['vertical', 'horizontal', 'inline']),
    }),
  };

  getChildContext() {
    return {
      form: {
        layout: this.props.layout,
      },
    };
  }

  isVertical = () => {
    return this.props.layout === 'vertical';
  };

  isHorizontal = () => {
    return this.props.layout === 'horizontal';
  };

  render() {
    const { layout, children, className, ...props } = this.props;

    const formClasses = clx('form', className, {
      horizontal: this.isHorizontal(),
      vertical: this.isVertical(),
    });

    return (
      <form className={formClasses} {...props}>
        {children}
      </form>
    );
  }
}
